import { Store } from "react-notifications-component";
import API from "./AxiosConfiguration";
import "animate.css/animate.min.css";
import moment from "moment";
import momentTz from "moment-timezone";
import { serializeError } from "eth-rpc-errors";
import CryptoJS from "crypto-js";

export const notificationType = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  DEFAULT: "default",
  DANGER: "danger",
};

export const notificationPosition = {
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  TOP_CENTER: "top-center",
  CENTER: "center",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_CENTER: "bottom-center",
};

export const saleType = {
  STANDARD: "standard",
  PRIVATE_SALE: "privateSale",
  PUBLIC_SALE: "publicSale",
};

export const GenesisTypes = {
  MALE: "Male",
  FEMALE: "Female",
  DUALGENDER: "Dual-Gender",
};

export const TimezoneTypes = {
  UTC: "UTC",
  LOCAL: "local",
  LONDON: "Europe/London",
};

export const urlQuery = {
  symbol: `?`,
  page: `page=`,
};

export const apiUrls = {
  checkUser: `check-user`,
  signUp: `signup`,
  addEvent: `fullcalendar-create`,
  updateEvent: `fullcalendar-update`,
  deleteEvent: `fullcalendar-delete`,
  listEvent: `event-list`,
  twentyFourHoursTraining: `get-hour-24-training`,
  iacProgramme: `get-iac-programme`,
  addLightWorker: `add-light-worker`,
  getSubjectList: `get-subject`,
  getCategoryList: `get-category`,
  getSummaryBenefit: `summary-benefit`,
  getTrainer: `get-trainer`,
  settings: `get-setting`,
  getEmail: `get-email`,
  addEmail: `email-add`,
  // getTimezone: `get-timezone-list`
  getTimezone: `https://fullcalendar.io/api/demo-feeds/timezones.json`,
  login: `login`,
  addressHash: `addressHash`,
  getGenesisToken: `get-genesis-tokens`,
  getSuperBabyToken: `get-super-baby-tokens-by-type`,
  checkSuperBabyTokensAvailable: `check-super-baby-tokens-available`,
  addMint: `add-mint`,
  addSuperBabyMint: `add-super-baby-mint`,
  getWalletScTokens: `get-wallet-sc-tokens`,
  walletAddressTransfer: `wallet-address-transfer`,
  getTokensByGender: `get-tokens-by-gender`,
  updateGenesisPair: `update-genesis-pair`,
  addMetamaskErrorLog: `add-metamask-error-log`,
  getSuperBabyMintedList: `super-baby-minted-list`,
};

export const superBabiesTypes = {
  SPACE: "SPACE",
  AIR: "AIR",
  WATER: "WATER",
  FIRE: "FIRE",
  EARTH: "EARTH",
};

export const lightWorkers = [
  {
    tokenId: 196,
    imageUrl: "196.png",
  },
  {
    tokenId: 198,
    imageUrl: "198.png",
  },
  {
    tokenId: 235,
    imageUrl: "235.png",
  },
  {
    tokenId: 243,
    imageUrl: "243.png",
  },
  {
    tokenId: 247,
    imageUrl: "247.png",
  },
  {
    tokenId: 670,
    imageUrl: "670.png",
  },
  {
    tokenId: 714,
    imageUrl: "714.png",
  },
  {
    tokenId: 797,
    imageUrl: "797.png",
  },
  {
    tokenId: 880,
    imageUrl: "880.png",
  },
  {
    tokenId: 911,
    imageUrl: "911.png",
  },
  {
    tokenId: 927,
    imageUrl: "927.png",
  },
  {
    tokenId: 1191,
    imageUrl: "1191.png",
  },
  {
    tokenId: 1310,
    imageUrl: "1310.png",
  },
  {
    tokenId: 1327,
    imageUrl: "1327.png",
  },
  {
    tokenId: 1372,
    imageUrl: "1372.png",
  },
  {
    tokenId: 1432,
    imageUrl: "1432.png",
  },
  {
    tokenId: 1490,
    imageUrl: "1490.png",
  },
  {
    tokenId: 1576,
    imageUrl: "1576.png",
  },
  {
    tokenId: 2029,
    imageUrl: "2029.png",
  },
  {
    tokenId: 2035,
    imageUrl: "2035.png",
  },
  {
    tokenId: 2096,
    imageUrl: "2096.png",
  },
  {
    tokenId: 2123,
    imageUrl: "2123.png",
  },
];

export const orderBy = {
  ASC: "asc",
  DESC: "desc",
};

export const commonMessages = {
  readyToFuse: "Ready To Fuse",
  publicSaleNotActive: "Public Sale is Not Active Yet",
  messageCustom: "Please Buy Super Creators IAC",
  toFuseBaby: "Pair First to Fuse Junior",
  saleCommingSoon: "Sale Coming Soon",
  saleIsOnHold: "Sale is on Hold",
  saleWillStartOn: "Sale will Start On",
  changePairConfirmation:
    "Once Paired The Date To Mint Your Next Junior May Change",
  defaultPair: "This is the Default Pair You are trying to Change",
  userCancelled: "Oops! You Cancelled the Request",
  genesisTooltip: "By Clicking on this Button you can Change the Genesis Pair",
};

export const errorMessages = {
  fourNotOne: "Sorry! Your session has been expired, Please login again.",
  fourNotTwo: "Sorry! The parameters were valid but the request failed.",
  fourNotThree:
    "Sorry! You have not the required permissions to perform this action.",
  fourNotFour: "404! Page not found.",
  fourNotNine:
    "Sorry! The request conflicts with another request (perhaps due to using the same idempotent key).",
  fourOneZero: "Sorry! Requested page is no longer available on the server.",
  fourOneNine: "Sorry!, Invalid request.",
  fourTwoNine:
    "Sorry! Too many requests hit the API too quickly. We recommend an exponential backoff of your requests.",
  fiveHoundredSeries:
    "Sorry! Something went wrong on Server's end. (These are rare).",
  noGenesisPairSelected: "No Genesis Pair Available to Manifest",
  genesisNotFound: "No Genesis Found in Your Wallet",
};

export const metamaskErrorMessages = {
  insufficientFund:
    "Please refresh this page if you think you have sufficient funds in your wallet!",
  browserNotSupported: "Not Supported in your browser",
  // "Not Supported in your browser, please switch to Chrome or Firefox!",
  addressNotWhitelisted: "Your address is not whitelisted in our records",
  typeTokensNotFound:
    "You don't have available this type of tokens in your wallet.",
};

export const networkType = {
  MAINNET: "Mainnet",
  TESTNET: "Testnet",
};

export const commonFields = {
  A: "A ",
  AN: "An ",
  THE: "The ",
  TO: "To",
  FROM: "From",
  OLD: "Old ",
  NEW: "New ",
  ID: "Id",
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  NAME: "Name",
  EMAIL: "Email ID",
  MOBILE_NUMBER: "Mobile Number",
  USERNAME: "Username",
  PHONE: "Phone No.",
  OTP: "OTP",
  PASSWORD: "Password",
  CONFIRM: "Confirm",
  ADDRESS: "Address",
  STREET: "Street",
  CITY: "City",
  DISTRICT: "District",
  STATE: "State",
  COUNTRY: "Country",
  PINCODE: "Pin Code",
  POSTALCODE: "Postal Code",
  TYPE: "Type",
  TITLE: "Title",
  SPACE: " ",
  MAX_FILE_SIZE: 2000000, // 2MB
  MAX_FILE_SIZE_3MB: 3000000, // 1MB
};

export const fileTypes = {
  APK: "application/vnd.android.package-archive",
  BMP: "image/bmp",
  BZIP_XPDF: "application/x-bzpdf",
  CSS: "text/css",
  CSV: "text/csv",
  DEB: "application/vnd.debian.binary-package",
  FONT_TTF: "application/x-font-ttf",
  FORM_URLENCODED: "application/x-www-form-urlencoded",
  FONT_WOFF: "application/font-woff",
  GIF: "image/gif",
  GZIP: "application/gzip",
  GZIP_XPDF: "application/x-gzpdf",
  HTML: "text/html",
  JPEG: "image/jpeg",
  JPG: "image/jpg",
  JSON: "application/json",
  JAVASCRIPT: "text/javascript",
  MS_EXCEL: "application/vnd.ms-excel",
  MS_EXCEL_2007:
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  MS_POWERPOINT: "application/vnd.ms-powerpoint",
  MS_POWERPOINT_2007:
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  MS_WORD: "application/msword",
  MS_WORD_2007:
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  MS_XPS: "application/vnd.ms-xpsdocument",
  OPENOFFICE_EXCEL: "application/vnd.oasis.opendocument.spreadsheet",
  OPENOFFICE_POWERPOINT: "application/vnd.oasis.opendocument.presentation",
  OPENOFFICE_TEXT: "application/vnd.oasis.opendocument.text",
  PDF: "application/pdf",
  PNG: "image/png",
  RAR: "application/x-rar-compressed",
  RTF: "text/rtf",
  SQL: "application/sql",
  SVG: "image/svg+xml",
  TIFF: "image/tiff",
  TXT: "text/plain",
  VCF: "text/vcard",
  XML: "application/xml",
  XPDF: "application/x-pdf",
  ZIP_7Z: "application/x-7z-compressed",
  ZIP: "application/zip",
};

export const allowedFileTypes = [
  // fileTypes.MS_EXCEL,
  // fileTypes.MS_EXCEL_2007,
  // fileTypes.OPENOFFICE_EXCEL,
  // fileTypes.MS_WORD,
  // fileTypes.MS_WORD_2007,
  // fileTypes.OPENOFFICE_TEXT,
  // fileTypes.PDF,
  // fileTypes.PDF,
  fileTypes.JPEG,
  fileTypes.JPG,
  fileTypes.PNG,
];

export const validationErrors = {
  INDIAN_MOBILE_NUMBER: "Enter a valid indian mobile number",
  VALID_MOBILE_NUMBER: "Enter a valid mobile number",
  ONLY_STRING: "Letters And Spaces Only Please!",
  ONLY_NUMBERS: "Digits Only Please!",
  ONLY_SPECIAL_CHAR: "Only Special Characters Please!",
  NO_SPECIAL_CHAR: "No Special Characters Please!",
  PLEASE_ENTER: "Please Enter ",
  MINIMUM_TEN_DIGITS: "Minimum Ten Digits Required",
  MAXIMUM_TEN_DIGITS: "Maximum Ten Digits Allowed",
  STRONG_PASSWORD:
    "Password Must contain at least one uppercase, one lowercase letter, one special character and at least one digit.",
  SAME_PASSWORD: "Entered value must be same as Password",
  TERMS_AND_CONDITION: "Please Accept Terms & Conditions",
};

export const metamaskChainDetails = [
  {
    decimal: 1,
    value: 1,
    hexId: 0x1,
    label: "Ethereum Main Network (Mainnet)",
    network: networkType.MAINNET,
  },
  {
    decimal: 3,
    value: 3,
    hexId: 0x3,
    label: "Ropsten Test Network",
    network: networkType.TESTNET,
  },
  {
    decimal: 4,
    value: 4,
    hexId: 0x4,
    label: "Rinkeby Test Network",
    network: networkType.TESTNET,
  },
  {
    decimal: 5,
    value: 5,
    hexId: 0x5,
    label: "Goerli Test Network",
    network: networkType.TESTNET,
  },
  {
    decimal: 42,
    value: 42,
    hexId: 0x2a,
    label: "Kovan Test Network",
    network: networkType.TESTNET,
  },
];

export const showNotification = (type, message, ...restParamsArray) => {
  const rest = restParamsArray[0];
  Store.addNotification({
    title: rest?.title,
    message: message,
    type: type === notificationType.ERROR ? notificationType.DANGER : type,
    insert: "top",
    container: rest.notificationPosition || notificationPosition.TOP_RIGHT,
    animationIn: ["animate__animated animate__fadeIn"],
    animationOut: ["animate__animated animate__fadeOut"],
    dismiss: {
      showIcon: rest.showCloseIcon || true,
      duration: rest.duration || 4000,
    },
  });
};

export const notificationSetting = () => {
  return {
    title: "",
    duration: 5000,
    notificationPosition: notificationPosition.BOTTOM_RIGHT,
  };
};

export const sendPostRequest = async (url, data, ...options) => {
  try {
    const response = await API.post(url, data, options);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const manageCounterProcessing = (buttonType, min, value, max) => {
  let newValue;
  // debugger;
  if (buttonType === "minus") {
    if (parseInt(value) <= parseInt(min)) {
      return parseInt(value);
    } else {
      newValue = parseInt(value) - 1;
    }
  } else if (buttonType === "plus") {
    if (parseInt(value) >= parseInt(max)) {
      return parseInt(value);
    } else {
      newValue = parseInt(value) + 1;
    }
  }
  return newValue;
};

export function checkEven(value) {
  // debugger;
  if (value && parseInt(value) > 0) {
    if (parseInt(value) % 2 === 0) {
      return true;
    }
  }
  return false;
}

export function checkOdd(value) {
  // debugger;
  if (value && parseInt(value) > 0) {
    if (parseInt(value) % 2 !== 0) {
      return true;
    }
  }
  return false;
}

export const checkEvenOddInArray = (array) => {
  let tempObj = {
    evenCount: 0,
    oddCount: 0,
    evenIndex: [],
    oddIndex: [],
  };
  if (array.length > 0) {
    for (let i = 0; i < array.length; i++) {
      if (checkEven(array[i])) {
        tempObj.evenCount++;
        tempObj.evenIndex.push(i);
      } else if (checkOdd(array[i])) {
        tempObj.oddCount++;
        tempObj.oddIndex.push(i);
      }
    }
  }
  return tempObj;
};

export const prepareGoogleEvent = (
  dataObject,
  startDateObject,
  endDateObject
) => {
  let url = `https://www.google.com/calendar/event?action=TEMPLATE`;
  url += `&text=${encodeURIComponent(dataObject?.title)}`;
  url += `&details=${encodeURIComponent(
    notUndefined(dataObject?.description) ? dataObject?.description : ""
  )}<hr/>Join Zoom Meeting: <a href="${dataObject?.link}">${
    dataObject?.link
  }</a>`;
  url += `&dates=${encodeURIComponent(
    `${startDateObject?.utcString}/${endDateObject?.utcString}`
  )}`;
  url += `&sprop=website:${encodeURIComponent(dataObject?.link)}`;
  window.open(url, "_blank");
};

export const prepareYahooEvent = (
  dataObject,
  startDateObject,
  endDateObject
) => {
  let url = `http://calendar.yahoo.com?v=60`;
  url += `&TITLE=${encodeURIComponent(dataObject?.title)}`;
  url += `&DESC=${encodeURIComponent(
    dataObject?.description
  )}<hr/>Join Zoom Meeting: <a href="${dataObject?.link}">${
    dataObject?.link
  }</a>`;
  url += `&ST=${startDateObject?.utcString}`;
  url += `&DUR=${_getDateDiff(dataObject?.start, dataObject?.end)}`;
  url += `&URL=${encodeURIComponent(dataObject?.link)}`;
  window.open(url, "_blank");
};

export const prepareOutlookEvent = (
  dataObject,
  startDateObject,
  endDateObject
) => {
  let url = `https://outlook.live.com/calendar/0/deeplink/compose?path=%2Fcalendar%2Faction%2Fcompose&rru=addevent`;
  url += `&startdt=${startDateObject?.utcString}`;
  url += `&enddt=${endDateObject?.utcString}`;
  url += `&allday=true`;
  url += `&body=${encodeURIComponent(
    dataObject?.description.replace(/\n/g, "<br>")
  )}<hr/>Join Zoom Meeting: <a href="${dataObject?.link}">${
    dataObject?.link
  }</a>`;
  url += `&location=World Wide Web`;
  url += `&subject=${_getDateDiff(dataObject?.title)}`;
  window.open(url, "_blank").focus();
};

export const prepareICSFile = (dataObject, startDateObject, endDateObject) => {
  let url = "";
  url =
    "BEGIN:VCALENDAR\n" +
    "VERSION:2.0\n" +
    "CALSCALE:GREGORIAN\n" +
    "BEGIN:VEVENT\n" +
    "DTSTAMP:" +
    startDateObject?.utcString +
    "\n" +
    "DTSTART:" +
    startDateObject?.utcString +
    "\n" +
    "DTEND:" +
    endDateObject?.utcString +
    "\n" +
    "DESCRIPTION:" +
    `${dataObject?.description}<hr/>Join Zoom Meeting: <a href="${dataObject?.link}">${dataObject?.link}</a>` +
    "\n" +
    "SUMMARY:" +
    dataObject?.title +
    "\n" +
    "LOCATION:World Wide Web" +
    "\n" +
    "STATUS:CONFIRMED\n" +
    "LAST-MODIFIED:" +
    ConvertToUTC(new Date())?.utcString +
    "\n" +
    "SEQUENCE:0\n" +
    "TRANSP:TRANSPARENT\n" +
    "END:VEVENT\n" +
    "END:VCALENDAR";

  download(dataObject?.title + ".ics", url);
  return url;
};

export function _getDatePart(part, digits) {
  part = part.toString();
  while (part.length < digits) {
    part = "0" + part;
  }
  return part;
}

function _getDateDiff(startDate, endDate) {
  var diff = Math.floor((endDate - startDate) / 60000),
    hours = Math.floor(diff / 60),
    mins = diff - hours * 60;
  return _getDatePart(hours, 2) + _getDatePart(mins, 2);
}

export function isToday(date) {
  if (date !== undefined) {
    const today = new Date();
    const dToC = new Date(date);
    // console.log(moment(date, ).format("ddd Do MMM YYYY"));
    const todayString = `${today.getFullYear().toString()}-${(
      today.getMonth() + 1
    ).toString()}-${today.getDate().toString()}`;
    const dToCString = `${dToC.getFullYear().toString()}-${(
      dToC.getMonth() + 1
    ).toString()}-${dToC.getDate().toString()}`;

    if (todayString === dToCString) return true;
  }
  return false;
}

export function displayEventDateInformation(startDate, endDate, ...rest) {
  let updatedDate = "";
  let tzEnabled;

  if (rest.length > 0 && rest[0]?.tzEnabled && notUndefined(rest[0]?.tz)) {
    tzEnabled = rest[0]?.tzEnabled;
  }
  if (notUndefined(startDate) && notUndefined(endDate)) {
    // console.log("Start:",moment(startDate).format("ddd Do MMM YYYY HH:MMA"));
    // console.log("End:",moment(endDate).format("ddd Do MMM YYYY HH:MMA"));
    if (
      moment(startDate, "DD-MM-YYYY").isSame(
        moment(endDate, "DD-MM-YYYY"),
        "day"
      ) &&
      moment(startDate, "DD-MM-YYYY").isSame(
        moment(endDate, "DD-MM-YYYY"),
        "date"
      )
    ) {
      updatedDate = `${
        tzEnabled
          ? momentTz(startDate).tz(rest[0]?.tz).format("ddd Do MMM YYYY hh:mmA")
          : moment(startDate).format("ddd Do MMM YYYY hh:mmA")
      } - ${
        tzEnabled
          ? momentTz(endDate).tz(rest[0]?.tz).format("hh:mmA")
          : moment(endDate).format("hh:mmA")
      } - ${processTimezone(endDate, rest[0]?.tz)}`;
    } else {
      updatedDate = `${
        tzEnabled
          ? momentTz(startDate).tz(rest[0]?.tz).format("ddd Do MMM YYYY hh:mmA")
          : moment(startDate).format("ddd Do MMM YYYY hh:mmA")
      } - ${
        tzEnabled
          ? momentTz(endDate).tz(rest[0]?.tz).format("ddd Do MMM YYYY hh:mmA")
          : moment(endDate).format("ddd Do MMM YYYY hh:mmA")
      } - ${processTimezone(endDate, rest[0]?.tz)}`;
    }
  }
  return updatedDate;
}

export function displayEventOnlyDateInformation(date, ...rest) {
  let updatedDate = "";
  let tzEnabled;

  if (rest.length > 0 && rest[0]?.tzEnabled && notUndefined(rest[0]?.tz)) {
    tzEnabled = rest[0]?.tzEnabled;
  }
  if (notUndefined(date)) {
    updatedDate = `${
      tzEnabled
        ? momentTz(date).tz(rest[0]?.tz).format("ddd Do MMM YYYY hh:mmA")
        : moment(date).format("ddd Do MMM YYYY hh:mmA")
    }`;
  }
  return updatedDate;
}

export function displayEventOnlyTimeInformation(date, ...rest) {
  let updatedTime = "";
  let tzEnabled;

  if (rest.length > 0 && rest[0]?.tzEnabled && notUndefined(rest[0]?.tz)) {
    tzEnabled = rest[0]?.tzEnabled;
  }
  if (notUndefined(date)) {
    updatedTime = `${
      tzEnabled
        ? momentTz(date).tz(rest[0]?.tz).format("hh:mmA")
        : moment(date).format("hh:mmA")
    }`;
  }
  return updatedTime;
}

export function ConvertToUTC(date) {
  if (date !== undefined) {
    let d = new Date(date);
    let yyyy = d.getFullYear().toString();
    let mm = _getDatePart((d.getMonth() + 1).toString(), 2); // getMonth() is zero-based
    let dd = _getDatePart(d.getDate().toString(), 2);
    let h = _getDatePart(d.getHours().toString(), 2);
    let i = _getDatePart(d.getMinutes().toString(), 2);
    let s = _getDatePart(d.getSeconds().toString(), 2);
    return {
      yyyy,
      mm,
      dd,
      h,
      i,
      s,
      utcString: `${yyyy}${mm}${dd}T${h}${i}${s}Z`,
    };
  }
  return { yyyy: "", mm: "", dd: "", h: "", i: "", s: "", utcString: "" };
}

function download(filename, fileBody) {
  var element = document.createElement("a");
  element.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," + encodeURIComponent(fileBody)
  );
  element.setAttribute("download", filename);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function isEmptyObject(obj) {
  if (obj && Object.keys(obj).length > 0) {
    return false;
  }
  return true;
}

export function manageUndefined(value) {
  if (value === "undefined" || value === undefined || value === null) {
    return "";
  }
  return value;
}

export function isUndefined(value) {
  if (value === "undefined" || value === undefined || value === null) {
    return true;
  }
  return false;
}

export function notUndefined(value) {
  if (value !== "" && value !== undefined && value !== null) {
    return true;
  }
  return false;
}

export function extractIPFSPrefix(value) {
  if (value !== "") {
    return value.split("ipfs://")[1];
  }
  return "";
}

export function appendIPFSBaseUrl(value) {
  if (value !== "") {
    return `https://ipfs.io/ipfs/${value}`;
  }
  return "";
}

export function validEmail(value) {
  if (value !== "") {
    // console.log(/\S+@\S+\.\S+/.test(value));
    return /\S+@\S+\.\S+/.test(value);
  }
  return false;
}

export const whitelistedAddress = [
  "0x54Ee9d0Ef39518ed43571dB034C10799D137cD26",
  "0x39842258E8d8AecBec3F4b5CFaab1219d2346cF8",
  "0xe0450FbEb0194E2fD049DABC935A3D9465cD3a91",
  "0x13870857b1212E7fb3dD602B990e5c780a563b34",
  "0xbf4BF6F8D3B3a8005F57eE90a063C84F5dD4F123",
  "0x812879D91771A13b430654704E307d9990701603",
  "0x7B3e0d23836201f5e45D665dfAa1Df9192a034b2",
  "0x1F5Db796E3Fe699d944A3a9aB3F95A2e316E2908",
  "0x7633fe30fbF1322f20378D45F5ab0dd8b84b9939",
  "0x72D6e4e54903FEE22f5BcaA7bBD01917d39c2cF8",
];

export function processTimezone(start, timeZone) {
  // debugger;
  var currentOffsetInHours, format;

  if (notUndefined(timeZone)) {
    currentOffsetInHours = moment(start)
      .tz(isUndefined(timeZone) ? "Asia/Calcutta" : timeZone)
      .format("Z");
  }
  if (currentOffsetInHours === "+00:00") {
    format = "UTC";
  } else {
    // format = `GMT${currentOffsetInHours}`;
    format = `UTC${currentOffsetInHours}`;
  }

  return format;
}

export const processMetamaskError = (error) => {
  if (!notUndefined(error)) return;
  let errorResponseObject = { status: false, hash: "" };
  let errorObject = serializeError(error);
  if (
    notUndefined(errorObject?.data) &&
    !isEmptyObject(errorObject?.data?.originalError)
  ) {
    const tempObject = errorObject?.data?.originalError;
    const code = notUndefined(tempObject?.error?.code)
      ? tempObject?.error?.code
      : notUndefined(tempObject?.code)
      ? tempObject?.code
      : errorObject?.code;
    const message = notUndefined(tempObject?.error?.message)
      ? tempObject?.error?.message
      : notUndefined(tempObject?.reason)
      ? tempObject?.reason
      : errorObject?.message;
    errorResponseObject.errorCode = code;
    errorResponseObject.message = shortenMessage(message, 150);
    errorResponseObject.fullMessage = message;
  } else {
    errorResponseObject.errorCode = errorObject?.code;
    errorResponseObject.message = shortenMessage(errorObject?.message);
    errorResponseObject.fullMessage = errorObject?.message;
  }
  console.error("Error is: ", errorResponseObject?.fullMessage);
  return errorResponseObject;
};

export const shortenMessage = (message, length = 100) => {
  if (!notUndefined(message)) return;
  return message?.length > length
    ? `${message?.substring(0, length)}...`
    : message;
};

export const encryptValue = (value) => {
  return CryptoJS.AES.encrypt(
    value,
    process.env.REACT_APP_SECRET_KEY
  ).toString();
};

export const decryptValue = (value) => {
  let bytes = CryptoJS.AES.decrypt(value, process.env.REACT_APP_SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const convertDifferenceFromADateIntoDays = (date) => {
  // If We want to Include as well, End Date Then Add + 1
  return parseInt(moment().diff(moment(date), "days") + 1);
};

export const reasons = {
  ABOVE_EQUAL_90: "Above or Equal 90 Days",
  BELOW_90: "Below 90 Days",
  ALREADY_MINTED: "Already Minted",
  ALREADY_MINTED_ABOVE: "Already Minted Above",
  NOT_EXIST_IN_WALLET: "Token Not Exist in Wallet",
};
